
import { Injectable } from '@angular/core';
import { StockItem } from 'src/app/core';
import { TypingsService } from '../../services';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'any' })
export class TypingResolver  {
  constructor(private typingsService: TypingsService) {}

  resolve(): Promise<StockItem[]> {
    return firstValueFrom(this.typingsService.all());
  }
}
